<script>
  export let idUnico = 'podcast';
  import Button from '../ui/button.svelte';
  import IoIosClose from 'svelte-icons/io/IoIosClose.svelte';
  export let arquivoMP3 = '';
  import navegacaoStore from '../../store';
  import { onMount } from 'svelte';
  export let content;
  let ativo = false;
  function abrir() {
    ativo = true;
  }

  console.log(idUnico);

  let podId = [];
  podId = idUnico.split('-');

  let comandoBegin;
  let comandoEnd;
  let comandoFrase;

  onMount(() => {
    let dados;

    navegacaoStore.subscribe((dadosStore) => {
      dados = dadosStore;
    });

    arquivoMP3 =
      dados.podcastPath + 'senad_m' + dados.modulo + '_u' + podId[1] + '_' + podId[2] + '.mp3';

    comandoBegin = content.search('<comando>');
    if (comandoBegin != -1) {
      comandoEnd = content.search('</comando>');
      if (comandoEnd != -1) {
        comandoFrase = content.substring(comandoBegin + 9, comandoEnd);
        content = content.substring(comandoEnd + 10, content.length);
      }
    }
  });
</script>

<div class="container" id={idUnico}>
  <p class="comando">
    {@html comandoFrase}
  </p>
  <div class="wrapper">
    <div class="title">
      <h3>TRECHO <b>NARRADO</b></h3>
    </div>
    <div class="caixa">
      <div class="icon-wrapper">
        <svg
          width="42"
          height="40"
          viewBox="0 0 42 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_0_1"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="42"
            height="40"
          >
            <path
              d="M20.9003 0.15C9.03033 1.28 -1.17967 10.07 0.11033 23.64C2.26033 46.26 26.9503 41.14 29.7603 30.28C32.0803 21.31 42.5403 20.66 41.5803 10.57C41.0803 5.25 34.1303 0 23.8703 0C22.9103 0 21.9203 0.0500013 20.9003 0.140001"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_0_1)">
            <path
              d="M42.5403 0.0100021H-1.17967V46.26H42.5403V0.0100021Z"
              fill="url(#paint0_linear_0_1)"
            />
          </g>
          <path
            d="M12.5603 11.7L9.87033 18.37L6.35033 20.47C5.79033 20.8 5.61033 21.52 5.93033 22.08L9.51033 28.28C9.84033 28.86 10.5903 29.05 11.1603 28.7L14.6103 26.58L21.7303 27.59C22.7103 27.73 23.4203 26.68 22.9203 25.82L14.6803 11.55C14.1903 10.7 12.9203 10.78 12.5503 11.7H12.5603Z"
            fill="white"
          />
          <path
            d="M24.6503 15.32C23.9403 14.09 22.8803 13.12 21.6303 12.53C20.7603 12.12 19.7303 12.68 19.5603 13.64V13.68C19.4403 14.32 19.7803 14.94 20.3703 15.22C21.0803 15.56 21.6803 16.11 22.0903 16.81C22.4903 17.51 22.6703 18.3 22.6103 19.09C22.5603 19.74 22.9303 20.34 23.5403 20.57H23.5703C24.4803 20.92 25.4803 20.31 25.5603 19.34C25.6703 17.96 25.3603 16.56 24.6503 15.33V15.32Z"
            fill="white"
          />
          <path
            d="M29.9003 12.39C29.9003 12.39 29.8703 12.34 29.8603 12.32C28.2403 9.6 25.6803 7.66 22.6703 6.83C21.8203 6.59 20.9503 7.19 20.8303 8.07C20.7303 8.81 21.2003 9.5 21.9203 9.7C24.1903 10.34 26.1203 11.81 27.3303 13.88C28.5103 15.97 28.8203 18.37 28.2403 20.66C28.0603 21.38 28.4203 22.13 29.1103 22.42C29.9303 22.76 30.8803 22.31 31.1003 21.45C31.8903 18.43 31.4903 15.25 29.9403 12.48C29.9403 12.48 29.9103 12.43 29.9003 12.4"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_0_1"
              x1="2.25193"
              y1="22.3548"
              x2="43.8919"
              y2="22.3548"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4DB4AA" />
              <stop offset="1" stop-color="#125375" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="conteudo">
        <div class="botoes">
          <div class="podcast-container">
            <audio controls="true" style="" controlsList="nodownload">
              <source src={arquivoMP3} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>

            <div class="button-wrapper">
              <button on:click={abrir} class="btn-label">
                <h3>Transcrição</h3>
                <i class="fa-solid fa-angles-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-container {ativo ? 'active' : ''}">
  <div class="background {ativo ? 'active' : ''}" on:click={() => (ativo = false)} />
  <div class="dialog">
    <div class="title">
      <h3>
        <slot name="titulo-transcricao">TRECHO TRANSCRITO</slot>
      </h3>
      <div class="botao-fechar" on:click={() => (ativo = false)}>
        <IoIosClose />
      </div>
    </div>
    <div class="text">
      <slot name="texto" />
      {#if false}
        <slot />
      {/if}
      {@html content}
    </div>
  </div>
</div>

<style>
  p.comando {
    padding: 0;
    margin: 0 0 1.5rem 0;
  }
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
    right: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(223, 223, 223);
    border-radius: 15px;
    padding: 5px 0;
  }
  .wrapper {
    position: relative;
    width: 100%;
    min-width: 250px;
  }
  .title {
    display: flex;
    /* justify-content: flex-end; */
  }
  .title :global(h3) {
    margin: 0;
    font-family: var(--FONT_ARCHI);
    color: #fff;
    /* font-weight: 600; */
    background: linear-gradient(90deg, #44a6a3, #2b7d8c, #155878);
    padding: 6px 15px 6px 65px;
    font-size: 24px;
    border-radius: 12.7px 20px 20px 0px;
  }
  .caixa {
    position: relative;
    display: flex;
  }
  .conteudo {
    width: calc(100%);
    /* width: calc(100% - 120px); */
    display: flex;
    justify-content: right;
    /* background: var(--COR_VERMELHO); */
  }
  audio::-webkit-media-controls-panel {
    /* background-color: #747c30; */
    background: #4cb3a9;
  }

  .botoes {
    background: #f1f3f4;
    margin: 0;
    padding: 0px 150px;
    color: #662482;
    font-family: var(--FONT_INTER);
    font-weight: 400;
    font-size: 17px;
    width: 100%;
    line-height: 27px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 0 15px 15px 15px;
    border: 2px solid #125375;
  }

  .icon-wrapper {
    position: absolute;
    top: -5px;
    transform: translateY(-75%);
    left: -18px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper svg {
    width: 70px;
    height: auto;
    filter: drop-shadow(0 0 3px #00000044);
  }

  .podcast-container {
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .button-wrapper {
    width: 100%;
    max-width: 300px;
  }

  .btn-label {
    margin-top: 25px;
    padding: 8px 24px;
    border-style: solid;
    border-width: 0px;
    background: #747c30;
    background: var(--COR_MOD_TER_POD_2);
    color: #125375;
    font-size: 18px;
    text-decoration: none;
    border-radius: 30px;
    border: 2px solid #125375;
    font-family: var(--FONT_INTER);
    font-weight: 300;
    opacity: 0.9;
    width: 100%;
    max-width: 300px;
  }

  .btn-label:hover {
    opacity: 1;
  }

  .btn-label:hover i {
    padding: 0 10px;
    transition: 200ms padding ease-in-out;
  }

  .btn-label i {
    transition: 200ms padding ease-in-out;
  }

  .btn-label {
    display: grid;
    grid-template-columns: 90% 10%;
    align-items: center;
    width: 100%;
  }

  .btn-label h3 {
    margin: 0;
    padding: 5px;
    color: #125375;
    font-family: var(--FONT_ARCHI);
    font-weight: 500;
    font-size: 24px;
  }

  .background,
  .dialog-container {
    visibility: hidden;
    position: fixed;
    left: 0;
    height: 100vh;
    width: 100vw;
    max-width: 100%;
    opacity: 0;
  }

  .background {
    top: 0;
    background: rgba(0, 0, 0, 0.308);
  }

  .dialog-container {
    top: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 400;
    transition: all 300ms ease;
  }
  .background.active,
  .dialog-container.active {
    visibility: visible;
    opacity: 1;
  }
  .dialog-container.active {
    transform: translateY(-50%);
    top: 50%;
  }
  .dialog {
    max-width: 36em;
    max-height: 90vh;
    padding: 30px 20px 0 20px;
    position: relative;
    z-index: 500;

    background: #898d68;
    background: var(--COR_MOD_TER_POD_2);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    border: 2px solid #125375;
    color: #222;
  }

  .dialog .title {
    display: flex;
    /* padding: 5px 20px; */
    position: relative;
    justify-content: center;
  }
  .dialog .title h3 {
    /* background: var(--COR_MOD_PRI); */
    background: transparent;
    padding: 0px 5px;
    color: #125375;
  }
  .dialog .text {
    padding: 20px 20px 30px 20px;
    font-family: var(--FONT_INTER);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: calc(90vh - 100px);
    font-size: 17px;
    color: #125375;
    font-weight: 400;
  }
  .dialog :global(p) {
    font-family: var(--FONT_INTER);
    color: #fff;
  }
  .botao-fechar {
    width: 50px;
    cursor: pointer;
    color: #125375;
    position: absolute;
    right: -10px;
    top: -3px;
    opacity: 0.8;
  }
  .botao-fechar:hover {
    opacity: 1;
  }
  .dialog-container :global(ul li),
  .dialog-container :global(ol li) {
    font-weight: 400;
    padding-left: 15px;
    color: #125375;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .dialog-container :global(::marker) {
    content: '\f054';
    color: #125375;
    font-family: 'Font Awesome 6 Free';
    font-weight: 700;
  }

  @media (max-width: 800px) {
    p.comando {
      margin: 0 0 3rem 0;
    }
    audio {
      max-width: 270px;
    }
    .botoes {
      width: 100%;
      padding: 50px 15px 30px 15px;
    }
    .icon-wrapper {
      top: -70px;
      transform: translateY(0px);
      left: -10px;
    }

    .icon-wrapper svg {
      width: 60px;
      height: unset;
      filter: drop-shadow(0 0 3px #00000044);
    }
    .dialog {
      width: 92vw;
    }
    .dialog .text {
      padding: 20px 10px 0px 10px;
    }
    .title h3 {
      padding: 6px 15px 6px 50px;
    }
    .button-wrapper {
      max-width: 270px;
    }
    .botao-fechar {
      width: 40px;
      right: -20px;
      top: -20px;
    }
    .dialog .title {
      margin-bottom: 10px;
    }
  }
</style>
